import Header from './components/Header.js';
import AppRoutes from './components/routes.tsx';
import Footer from './components/footer.js';
import './styles/App.css';
import { HashRouter } from 'react-router-dom';


function App() {
  return (
    <>
      <HashRouter>
        <Header />
        <AppRoutes />
        <Footer />
      </HashRouter>
    </>
  );
}

export default App;
